import "jquery-validation"
import axios from "axios"
import toastr from "toastr"

class UserPortal {
  constructor() {
    this.init()
  }

  init () {
    this.cacheDOM()
    this.bindEvents()
    this.login()
  }

  cacheDOM () {
    this.$login_form = $( '#id-login-form' )
  }

  bindEvents () {

  }

  login () {
    const SELF = this

    this.$login_form.validate( {
      submitHandler: function ( form ) {
        SELF.post_login( form )
        return false
      },
    } )
  }

  async post_login ( form ) {
    const formData = $( form ).serialize()

    const res = await axios.post( $( form ).attr( 'action' ), formData )
      .catch( data => {
        $.each( data.response.data.data, function ( i, v ) {
          toastr.error( v )
        } )

      } )

    if ( true === res?.data?.success ) {
      location.reload();
    }
  }
}

new UserPortal()
